"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var reactHelpers_1 = require("../utils/reactHelpers");
var FormControl_1 = __importDefault(require("../FormControl"));
var uid_1 = __importDefault(require("../utils/uid"));
var ButtonIcon_1 = __importDefault(require("../Button/ButtonIcon"));
var SvgShow_1 = __importDefault(require("../Icon/SvgShow"));
var SvgHide_1 = __importDefault(require("../Icon/SvgHide"));
var InputSCWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n\n  /* input */\n  input {\n    color: inherit;\n    width: 100%;\n    outline: 0;\n    height: ", ";\n    border-radius: ", ";\n    border: 1px solid ", ";\n    padding: ", ";\n\n    ._ndsFormControl:hover & {\n      border-color: ", ";\n    }\n\n    &:focus,\n    &:active {\n      box-shadow: ", "\n        ", ";\n      border-color: ", ";\n    }\n    will-change: box-shadow;\n    transition: box-shadow 0.3s;\n  }\n\n  /* input-icon */\n  ._ndsInput__icon {\n    display: flex;\n    align-items: center;\n    margin-left: -2.5rem;\n    > button {\n      margin: 0;\n    }\n    /* position: static; */\n    /* display: inline-block; */\n    /* top: 50%; */\n    /* right: -0.25rem; */\n    /* transform: translateY(-1.5rem); */\n  }\n\n  /* error */\n  &._ndsInput--error input {\n    ._ndsFormControl:hover &,\n    & {\n      border-color: ", ";\n    }\n    &:focus,\n    &:active {\n      box-shadow: ", "\n        ", ";\n    }\n  }\n\n  /* disabled */\n  &._ndsInput--disabled input {\n    user-select: none;\n\n    ._ndsFormControl:hover &,\n    & {\n      border-color: ", ";\n    }\n    &:focus,\n    &:active {\n      box-shadow: none;\n    }\n    color: ", ";\n    background-color: ", ";\n  }\n\n  /* with Icon */\n  &._ndsInput--hasIcon input {\n    padding-right: 2.5rem;\n  }\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n\n  /* input */\n  input {\n    color: inherit;\n    width: 100%;\n    outline: 0;\n    height: ", ";\n    border-radius: ", ";\n    border: 1px solid ", ";\n    padding: ", ";\n\n    ._ndsFormControl:hover & {\n      border-color: ", ";\n    }\n\n    &:focus,\n    &:active {\n      box-shadow: ", "\n        ", ";\n      border-color: ", ";\n    }\n    will-change: box-shadow;\n    transition: box-shadow 0.3s;\n  }\n\n  /* input-icon */\n  ._ndsInput__icon {\n    display: flex;\n    align-items: center;\n    margin-left: -2.5rem;\n    > button {\n      margin: 0;\n    }\n    /* position: static; */\n    /* display: inline-block; */\n    /* top: 50%; */\n    /* right: -0.25rem; */\n    /* transform: translateY(-1.5rem); */\n  }\n\n  /* error */\n  &._ndsInput--error input {\n    ._ndsFormControl:hover &,\n    & {\n      border-color: ", ";\n    }\n    &:focus,\n    &:active {\n      box-shadow: ", "\n        ", ";\n    }\n  }\n\n  /* disabled */\n  &._ndsInput--disabled input {\n    user-select: none;\n\n    ._ndsFormControl:hover &,\n    & {\n      border-color: ", ";\n    }\n    &:focus,\n    &:active {\n      box-shadow: none;\n    }\n    color: ", ";\n    background-color: ",
    ";\n  }\n\n  /* with Icon */\n  &._ndsInput--hasIcon input {\n    padding-right: 2.5rem;\n  }\n"])), function (p) { return p.theme.SizeFontInputBase; }, function (p) { return p.theme.SizeLineHeightInputBase; }, function (p) { return p.theme.ColorFontInputBase; }, function (p) { return p.theme.SizeHeightInputBase; }, function (p) { return p.theme.SizeBorderRadiusDefault; }, function (p) { return p.theme.ColorBorderInputBase; }, function (p) { return p.theme.SizePaddingInputBase; }, function (p) { return p.theme.ColorBorderInputHover; }, function (p) { return p.theme.SizeShadowInputActive; }, function (p) { return p.theme.ColorShadowInputActive; }, function (p) { return p.theme.ColorBorderInputActive; }, function (p) { return p.theme.ColorBorderError; }, function (p) { return p.theme.SizeShadowInputActive; }, function (p) { return p.theme.ColorShadowInputErrorActive; }, function (p) { return p.theme.ColorBorderInputDisabled; }, function (p) { return p.theme.ColorFontInputDisabled; }, function (p) {
    return p.theme.ColorBackgroundInputDisabled;
});
var Input = function (props) {
    var label = props.label, helpText = props.helpText, inputIcon = props.inputIcon, autoFocus = props.autoFocus, disabled = props.disabled, error = props.error, fullWidth = props.fullWidth, readOnly = props.readOnly, required = props.required, id = props.id, name = props.name, type = props.type, valueProp = props.value, classNameProp = props.className, onChange = props.onChange, inputRef = props.inputRef, forwardedRef = props.forwardedRef, placeholder = props.placeholder, isMasked = props.isMasked, hidePasswordEye = props.hidePasswordEye, others = __rest(props, ["label", "helpText", "inputIcon", "autoFocus", "disabled", "error", "fullWidth", "readOnly", "required", "id", "name", "type", "value", "className", "onChange", "inputRef", "forwardedRef", "placeholder", "isMasked", "hidePasswordEye"]);
    var isControlled = react_1.default.useRef(valueProp != null).current;
    var _a = react_1.default.useState(valueProp || ''), valueState = _a[0], setValueState = _a[1];
    var _b = react_1.default.useState(false), showPasswordState = _b[0], setShowPasswordState = _b[1];
    var inputId = react_1.default.useMemo(function () { return id || uid_1.default('_ndsInput_'); }, [id]);
    var helpTextId = "help-text-" + inputId;
    var isPassword = type === 'password';
    var value = isControlled ? valueProp : valueState;
    var InputComponentToRender = isMasked ? react_input_mask_1.default : 'input';
    var showPasswordIcon = isPassword && !hidePasswordEye;
    var handleToggleShowPassword = react_1.default.useCallback(function () {
        if (disabled) {
            return;
        }
        setShowPasswordState(!showPasswordState);
    }, [disabled, showPasswordState]);
    var handleChange = react_1.default.useCallback(function (event) {
        if (!isControlled) {
            setValueState(event.target.value);
        }
        if (onChange) {
            onChange(event);
        }
    }, [onChange, isControlled]);
    var renderType = function () {
        if (isPassword && showPasswordState) {
            return 'text';
        }
        return type;
    };
    var classes = clsx_1.default('_ndsInput', { '_ndsInput--error': error === true }, { '_ndsInput--disabled': disabled === true }, { '_ndsInput--fullWidth': fullWidth === true }, { '_ndsInput--hasIcon': inputIcon != null || type === 'password' }, classNameProp);
    var otherInputProps = {};
    if (isMasked) {
        others.maskChar = others.maskChar || null;
        otherInputProps.inputRef = inputRef;
    }
    else {
        otherInputProps.ref = inputRef;
    }
    return (react_1.default.createElement(FormControl_1.default, { ref: forwardedRef, className: classNameProp, disabled: disabled, error: error, required: required, fullWidth: fullWidth, inputId: inputId, helpTextId: helpTextId, label: label, helpText: helpText },
        react_1.default.createElement(InputSCWrapper, { className: classes },
            react_1.default.createElement(InputComponentToRender, __assign({ "aria-describedby": helpTextId, autoFocus: autoFocus, disabled: disabled, readOnly: readOnly, required: required, id: inputId, name: name, type: renderType(), value: value, onChange: handleChange }, others, otherInputProps)),
            showPasswordIcon ? (react_1.default.createElement("div", { className: "_ndsInput__icon" },
                react_1.default.createElement(ButtonIcon_1.default, { color: "grey", onClick: handleToggleShowPassword, type: "button" }, showPasswordState ? react_1.default.createElement(SvgShow_1.default, null) : react_1.default.createElement(SvgHide_1.default, null)))) : (inputIcon && react_1.default.createElement("div", { className: "_ndsInput__icon" }, inputIcon)))));
};
exports.InputRootComp = Input;
Input.propTypes = {
    label: prop_types_1.default.string.isRequired,
    helpText: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.shape({
            title: prop_types_1.default.string,
            validations: prop_types_1.default.arrayOf(prop_types_1.default.shape({
                message: prop_types_1.default.string,
                isValid: prop_types_1.default.bool
            }))
        })
    ]),
    inputIcon: prop_types_1.default.element,
    autoFocus: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    error: prop_types_1.default.bool,
    fullWidth: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    id: prop_types_1.default.string,
    name: prop_types_1.default.string,
    type: prop_types_1.default.string,
    value: prop_types_1.default.any,
    className: prop_types_1.default.string,
    inputRef: prop_types_1.default.any,
    forwardedRef: prop_types_1.default.any,
    isMasked: prop_types_1.default.bool,
    hidePasswordEye: prop_types_1.default.bool
};
Input.defaultProps = {
    helpText: undefined,
    inputIcon: undefined,
    autoFocus: false,
    disabled: false,
    error: false,
    fullWidth: false,
    readOnly: false,
    required: false,
    id: undefined,
    name: undefined,
    type: 'text',
    value: undefined,
    className: undefined,
    onChange: undefined,
    forwardedRef: null,
    inputRef: null,
    isMasked: false,
    hidePasswordEye: false
};
exports.default = reactHelpers_1.withForwardedRef(Input);
var templateObject_1;
//# sourceMappingURL=Input.js.map